<template>
  <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Nieuwe gebruiker aanmaken" @hidden="$emit('close')">
    <b-form @submit="onSubmit">
       <b-form-group id="input-group-1" label="Gebruikersnaam" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.username"
          placeholder="Vul gebruikersnaam in"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Wachtwoord" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.password"
          type="password"
          placeholder="Vul een wachtwoord in"
          required
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary">Submit</b-button>
    </b-form>
  </b-modal>
</template>
<script>
  export default {
    data () {
      return {
        form: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      onSubmit (event) {
        event.preventDefault()
        const data = {
          username: this.form.username,
          password: this.form.password
        }

        this.$http.post(`/users`, data)
        .then((response) => {
          this.$swal('Hoera 😊', `De gebruiker is succesvol aangemaakt.`, 'success')
          this.$emit('userCreated')
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.`, 'error')
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// CreateNewUserModal.vue?c8072704